<template>
    <div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                ФИО заказчика <span class="red-text">*</span>
            </div>
            <input type="text" class="cd-modal-text-input" v-model="name">
            <div class="form-alert-danger" v-show="showAlert === 'name'">
                Обязательное поле!
            </div>
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Контактный телефон
            </div>
            <input type="text" class="cd-modal-text-input" v-model="phone"
                   v-mask="'+# (###) ### ## ##'" v-on:focus="addCountryCode">
            <div class="form-alert-danger" v-show="showAlert === 'phone'">
                Обязательное поле!
            </div>
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                E-mail <span class="red-text">*</span>
            </div>
            <input type="text" class="cd-modal-text-input" v-model="email">
            <div class="form-alert-danger" v-show="showAlert === 'email'">
                Обязательное поле!
            </div>
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Город
            </div>
            <input type="text" class="cd-modal-text-input" v-model="city">
            <div class="form-alert-danger" v-show="showAlert === 'city'">
                Обязательное поле!
            </div>
        </div>
        <div class="modal-button" v-on:click="apply">
            Сохранить
        </div>
    </div>
</template>

<script>
export default {
    name: "DataEntryForCustomers",
    data(){
      return {
          name: '',
          phone: '',
          email: '',
          city: '',
          necessaryFields: [
              'name',
              'email'
          ],
          showAlert: ''
      }
    },
    props:{
        buttonName:{
            type: String
        },
        dataCustomer:{
            type: Object,
            default(){
                return {};
            }
        }
    },
    methods:{
        addCountryCode() {
            if (this.phone === '') {
                this.phone = 7
            }
        },
        checkNecessary(data) {
            for (let field in this.necessaryFields) {
                console.log(field, data)
                if (!data[this.necessaryFields[field]]) {
                    console.log(this.necessaryFields[field])
                    return this.necessaryFields[field]
                }
            }
            return true
        },
        apply(){
            let data = {
                name: this.name,
                phone: this.phone,
                email: this.email,
                city: this.city,
            }
            let checkResult = this.checkNecessary(data)
            if (checkResult === true) {
                this.$emit('apply', data);
            } else {
                this.showAlert = checkResult
            }
        }
    },
    mounted() {
        if(Object.keys(this.dataCustomer).length !== 0){
            this.name = this.dataCustomer.name;
            this.phone = this.dataCustomer.phone;
            this.email = this.dataCustomer.email;
            this.city = this.dataCustomer.city;
        }
    }
}
</script>

<style scoped>

</style>
